import { DEFAULT_STATE } from '../constants'

export const initialStylesState = {
  styles: DEFAULT_STATE.styles,
}
